<template>
  <section>
    <b-modal width="680px" :active.sync="isCardModalActive">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title" v-if="searchPartsConfirm(scenarioTable)">
            パーツの全確定
          </p>
          <p class="card-header-title" v-else>
            パーツの全確定解除
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-primary" has-icon v-if="searchPartsConfirm(scenarioTable)">
              すべてのパーツを確定します。
            </b-message>
            <b-message type="is-primary" has-icon v-else>
              すべてのパーツの確定を解除します。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="isCardModalActive = false">いいえ</a>
          <a class="card-footer-item" @click="clickPartsConfirm(true)" v-if="searchPartsConfirm(scenarioTable)">はい</a>
          <a class="card-footer-item" @click="clickPartsConfirm(false)" v-else>はい</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'ModalExportListScenario',
  data () {
    return {
      isCardModalActive: false,
      templateName: '',
      author: ''
    }
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('chatbot', ['scenarioTable', 'isModalAllPartsConfirmListScenario', 'selectScenario', 'selectChatbot']),
    ...mapState('auth', ['user'])
  },
  watch: {
    isModalAllPartsConfirmListScenario () {
      this.isCardModalActive = this.isModalAllPartsConfirmListScenario
    },
    isCardModalActive () {
      this.isCardModalActive ? console.log('isCardModalActive: true') : this.$store.dispatch('chatbot/closeModalScenario')
    }
  },
  methods: {
    searchPartsConfirm (scenario) {
      for (var s of scenario) {
        if (!s.is_confirm) {
          return true
        }
      }
      return false
    },
    clickPartsConfirm (flg) {
      if (flg) {
        this.sendControlLogRelatedChatBot('パーツ全確定', 'シナリオ編集画面にて、「パーツ全確定」を実行。', this.selectChatbot)
      }
      else {
        this.sendControlLogRelatedChatBot('パーツ確定全解除', 'シナリオ編集画面にて、「パーツ全確定解除」を実行。', this.selectChatbot)
      }

      console.debug('*** Start *** clickExportScenarioList')
      this.$store.dispatch('chatbot/scenarioPartsConfirm', {
        companyid: this.user.companyID,
        scenarioName: this.selectScenario,
        flg: flg
      })
      this.isCardModalActive = false
      console.debug('*** End *** clickExportScenarioList')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ui/ModalAllPartsConfirmListScenario.vue